export const setIsOpenMenu = () => ({
    type: "SET_OPEN_MENU"
});

export const setIsCloseMenu = () => ({
    type: "SET_CLOSE_MENU"
});
